import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import CardInteractive from '@/components/layout/CardInteractive.vue';
import store from '@/store';
import NumberAnimation from '@/components/numberAnimation/NumberAnimation.vue';
var PlatformPreview = /*#__PURE__*/function (_Vue) {
  function PlatformPreview() {
    var _this;
    _classCallCheck(this, PlatformPreview);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PlatformPreview, [].concat(args));
    _defineProperty(_this, "platform", void 0);
    _defineProperty(_this, "loading", void 0);
    _defineProperty(_this, "errorMsg", void 0);
    return _this;
  }
  _inherits(PlatformPreview, _Vue);
  return _createClass(PlatformPreview, [{
    key: "logo",
    get: function get() {
      return this.platform.logo;
    }
  }, {
    key: "name",
    get: function get() {
      return this.platform.name;
    }
  }, {
    key: "color",
    get: function get() {
      return this.platform.color;
    }
  }, {
    key: "nbSpeachPublish",
    get: function get() {
      return this.getSummaryDataGivenAttribute('nbSpeachPublish');
    }
  }, {
    key: "nbNewSpeachWeek",
    get: function get() {
      return this.getSummaryDataGivenAttribute('nbNewSpeachWeek');
    }
  }, {
    key: "nbNewSpeachMonth",
    get: function get() {
      return this.getSummaryDataGivenAttribute('nbNewSpeachMonth');
    }
  }, {
    key: "nbUser",
    get: function get() {
      return this.getSummaryDataGivenAttribute('nbUser');
    }
  }, {
    key: "nbSpeachMakers",
    get: function get() {
      return this.getSummaryDataGivenAttribute('nbSpeachMaker');
    }
  }, {
    key: "nbAdmins",
    get: function get() {
      return this.getSummaryDataGivenAttribute('nbAdmin');
    }
  }, {
    key: "getSummaryDataGivenAttribute",
    value: function getSummaryDataGivenAttribute(attribute) {
      var summary = store.getters.summary(this.platform);
      if (summary === undefined) {
        return 0;
      }
      return summary[attribute];
    }
  }]);
}(Vue);
__decorate([Prop()], PlatformPreview.prototype, "platform", void 0);
__decorate([Prop({
  default: false
})], PlatformPreview.prototype, "loading", void 0);
__decorate([Prop({
  default: ''
})], PlatformPreview.prototype, "errorMsg", void 0);
PlatformPreview = __decorate([Options({
  components: {
    NumberAnimation: NumberAnimation,
    CardInteractive: CardInteractive
  }
})], PlatformPreview);
export default PlatformPreview;